var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('members-caption',[_vm._v(" 連絡先 ")]),_c('contact-info'),_c('members-caption',[_vm._v(" メンバー状況 ")]),_c('total'),_c('list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }